import _toConsumableArray from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VnpInput from '@/components/vant-number-plate/vnp-input';
import { Dialog } from "vant";
import { encrypt } from "@/assets/utils/cryptoUtil";
import { addParking } from "@/api/module/user";
export default {
  components: {
    'vnp-input': VnpInput
  },
  data: function data() {
    return {
      value: '',
      searchHistory: [],
      //历史查询记录
      serialno: '',
      pickUpTips: window.g.PickUpTips // 提示内容

    };
  },
  created: function created() {
    Dialog({
      message: this.pickUpTips,
      confirmButtonText: '我知道了',
      theme: 'round-button'
    });
    this.serialno = encrypt(this.$route.query.serialno);
    var storedHistory = window.localStorage.getItem('PlateData');

    if (storedHistory) {
      this.searchHistory = JSON.parse(storedHistory);
    }
  },
  methods: {
    // 提交车牌号
    submit: function submit() {
      var _this = this;

      if (this.value.length < 7) {
        Dialog.alert({
          message: '请输入正确的车牌号'
        });
        return;
      }

      var params = {
        patientid: this.serialno,
        plate: this.value
      };
      addParking(params).then(function (res) {
        if (res.data == '1') {
          Dialog.alert({
            message: "领取成功！即将跳转"
          }).then(function () {
            _this.$router.go(-1);
          });
        } else {
          Dialog.alert({
            message: res.msg
          });
        } // 定义存储键名


        var SEARCH_KEY = 'PlateData'; // 如果搜索历史已达上限，移除最旧记录

        var maxHistoryLength = 10; // 例如，最多保留10条记录

        if (_this.searchHistory.length >= maxHistoryLength) {
          _this.searchHistory.shift();
        } // 添加至搜索历史


        _this.searchHistory.push(_this.value);

        _this.searchHistory = _this.removeDuplicates(_this.searchHistory); // 存储到 session storage
        // sessionStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));

        window.localStorage.setItem(SEARCH_KEY, JSON.stringify(_this.searchHistory));
      });
    },
    // 从 session storage 中获取搜索历史
    searchHistoryClick: function searchHistoryClick(item) {
      this.value = item.split(".")[0];
    },
    removeDuplicates: function removeDuplicates(arr) {
      return _toConsumableArray(new Set(arr));
    },
    // 清除所有搜索历史
    clearSearchHistory: function clearSearchHistory() {
      this.searchHistory = [];
      sessionStorage.removeItem('searchHistory');
    },
    // 删除指定索引处的记录
    removeSearchRecord: function removeSearchRecord(index) {
      this.searchHistory.splice(index, 1);
      sessionStorage.setItem('searchHistory', JSON.stringify(this.searchHistory));
    }
  }
};